import { useTranslation } from 'react-i18next';
import { ReactNode } from 'react';
import Modal from 'shared/overlays/Modal';

interface ConfirmationModalProps {
  message: ReactNode;
  title?: ReactNode;
  show?: boolean;
  onConfirm: () => void;
  onDecline: () => void;
  busy?: boolean;
  centered?: boolean;
}

const ConfirmationModal = ({ message, show = false, onConfirm, onDecline, busy = false, centered = false }: ConfirmationModalProps) => {
  const { t } = useTranslation('common');

  return (
    <Modal show={show} onClose={onDecline} centered={centered}>
      <div className="text-center p-5">{message}</div>
      <div className="d-flex justify-content-end mt-4">
        <button onClick={onDecline} type="button" className="btn">
          {t('cancel')}
        </button>
        <button disabled={busy} type="button" onClick={onConfirm} className="btn btn-danger">
          {t('confirm')}
        </button>
      </div>
    </Modal>
  );
};

export default ConfirmationModal;
